const React = require('react');
const { Dark, Default, Flat, Bootstrap } = require('./Images/Themes');
const { Approved, InProgress, Refused } = require('./Images/Status');
const { PAYMENTS_ID } = require('./constants');
// const { MCO, MLA, MLB, MLC, MLM, MLU, MPE } = require('./Images/Countries');

const defaultAdvancedColorsOptions = {
  textPrimaryColor: '',
  textSecondaryColor: '',
  inputBackgroundColor: '',
  formBackgroundColor: '',
  baseColor: '',
  baseColorFirstVariant: '',
  baseColorSecondVariant: '',
  errorColor: '',
  successColor: '',
  outlinePrimaryColor: '',
  outlineSecondaryColor: '',
  buttonTextColor: '',
  fontSizeExtraSmall: '',
  fontSizeSmall: '',
  fontSizeMedium: '',
  fontSizeLarge: '',
  fontSizeExtraLarge: '',
  fontWeightNormal: '',
  fontWeightSemiBold: '',
  formInputsTextTransform: '',
  inputVerticalPadding: '',
  inputHorizontalPadding: '',
  inputFocusedBoxShadow: '',
  inputErrorFocusedBoxShadow: '',
  inputBorderWidth: '',
  inputFocusedBorderWidth: '',
  borderRadiusSmall: '',
  borderRadiusMedium: '',
  borderRadiusLarge: '',
  borderRadiusFull: '',
  formPadding: '',
};

const defaultAdvancedTextOptions = {
  ctaGeneralErrorLabel: '',
  ctaCardErrorLabel: '',
  ctaReturnLabel: '',
};

function componentProps(i18n, lang) {
  return {
    title: i18n.gettext('Status Screen Brick'),
    description: i18n.gettext('Construye y comprueba la experiencia visual en tiempo real. Cuando esté todo listo, descarga o copia el código generado para agregarlo a tu sitio web o compartirlo con un desarrollador.'),
    breadCrumbLevels: [
      {
        text: i18n.gettext('Documentación'),
        id: '1',
        href: `/developers/${lang}/docs`,
      },
      {
        text: i18n.gettext('Checkout Bricks'),
        id: '2',
        href: `/developers/${lang}/docs/checkout-bricks/landing`,
      },
      {
        text: i18n.gettext('Status Screen Brick'),
        id: '3',
        href: `/developers/${lang}/docs/checkout-bricks/status-screen-brick/introduction`,
      },
      {
        text: i18n.gettext('Demostración'),
        id: '4',
        disabled: true,
      },
    ],
    publicKey: 'TEST-2e029af2-a6e2-4229-8fca-886fde65f16e',
    optionsDescription: i18n.gettext('Configuración básica'),
    mobileDescription: i18n.gettext('Ingresa a la Demostración en una computadora para hacer configuraciones más avanzadas y tener acceso al código generado.'),
    languages: [
      {
        description: i18n.gettext('Português'),
        value: 'pt-BR',
      },
      {
        description: i18n.gettext('Español'),
        value: 'es-AR',
      },
      {
        description: i18n.gettext('English'),
        value: 'en-US',
      },
    ],
    options: [
      {
        id: 'paymentId',
        type: 'dropdown',
        label: i18n.gettext('Status'),
        placeholder: i18n.gettext('Status'),
        trackingLabel: 'STATUS',
        defaultValue: PAYMENTS_ID.approved,
        tooltipContent: i18n.gettext('El propósito de este campo es ejemplificar en la demostración el status en el proceso de checkout, sin establecer ninguna conexión con el estado de pago real de la integración. La información del status de la transacción se obtiene automáticamente a través de la integración.'),
        items: [
          { value: PAYMENTS_ID.approved, primary: i18n.gettext('Aprobado'), icon: <Approved /> },
          { value: PAYMENTS_ID.pending, primary: i18n.gettext('Procesando'), icon: <InProgress /> },
          { value: PAYMENTS_ID.rejected, primary: i18n.gettext('Rechazado'), icon: <Refused /> },
        ],
        width: 'full',
      },
      {
        id: 'theme',
        type: 'dropdown',
        label: i18n.gettext('Tema'),
        placeholder: i18n.gettext('Tema'),
        trackingLabel: 'THEME',
        defaultValue: 'default',
        items: [
          { value: 'default', primary: i18n.gettext('Default'), icon: <Default /> },
          { value: 'dark', primary: i18n.gettext('Dark'), icon: <Dark /> },
          { value: 'bootstrap', primary: i18n.gettext('Bootstrap'), icon: <Bootstrap /> },
          { value: 'flat', primary: i18n.gettext('Flat'), icon: <Flat /> },
        ],
        width: 'full',
      },
      {
        id: 'switchLabel',
        type: 'label',
        label: i18n.gettext('Mostrar en el layout'),
      },
      {
        id: 'showExternalReference',
        type: 'switch',
        trackingLabel: 'EXTERNAL_REFERENCE',
        label: i18n.gettext('Referencia externa'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
      {
        id: 'showTransactionDate',
        type: 'switch',
        trackingLabel: 'TRANSACTION_DATE',
        label: i18n.gettext('Fecha de transacción'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
      {
        id: 'showStatusDetails',
        type: 'switch',
        trackingLabel: 'STATUS_DETAIL',
        label: i18n.gettext('Detalles de procesamiento'),
        tooltipContent: i18n.gettext('Los detalles del procesamiento de pagos se muestran de manera predeterminada cuando hay información relevante, como un informe de que los detalles de la tarjeta se ingresaron incorrectamente u otros resultados de la creación de un pago. Es posible deshabilitar estos detalles por esta propiedad'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
    ],
    advancedOptionsDescription: i18n.gettext('Configuraciones avanzadas'),
    advancedOptions: [
      {
        id: 'customVariables',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Personaliza los colores con códigos hexadecimales'),
        linkDescription: i18n.gettext('Más información en la documentación'),
        linkUrl: 'docs/checkout-bricks/additional-content/modify-css-variables',
        defaultValue: JSON.stringify(
          defaultAdvancedColorsOptions,
          null,
          2,
        ),
      },
      {
        id: 'customTexts',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Cambiar textos'),
        linkDescription: i18n.gettext('Más información en la documentación'),
        linkUrl: 'docs/checkout-bricks/card-payment-brick/additional-customization/modify-texts',
        defaultValue: JSON.stringify(
          defaultAdvancedTextOptions,
          null,
          2,
        ),
      },
    ],
  };
}

function getProps(i18n, lang) {
  return componentProps(i18n, lang);
}

module.exports = { getProps, defaultAdvancedColorsOptions, defaultAdvancedTextOptions };
